import { SelectOptionType } from '@octano/global-ui';
import { getAllUsers } from '../api';

export const useSearchUsers = () => {
  return async (
    searchText: string,
    selected: any[],
  ): Promise<SelectOptionType[]> => {
    const { data } = await getAllUsers(searchText);
    if (!data) {
      return [];
    }
    return data
      .filter((user) => !selected?.some((c) => c.value === user.accountId))
      .map((user) => ({
        label: `${user.name}, ${user.identification}${
          user?.rolName ? `, ${user.rolName}` : ''
        } (${user.email})`,
        value: user.accountId,
        name: user.name,
        email: user.email,
      })) as SelectOptionType[];
  };
};
